export const detectDevice = () => {
  const userAgent = navigator.userAgent;

  const isMobile = window.innerWidth < 900;
  

  let mobileOS = null;

  if (/Android/i.test(userAgent)) {
    mobileOS = "Android";
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    mobileOS = "iOS";
  }

  console.log("Is it mobile?", isMobile, mobileOS)

  return {
    isMobile,
    mobileOS,
  };
};
